/**
 * PaymentOrderSummary.jsx - Order summary with line items and tip selector
 */
import React from 'react';
import { Store } from 'lucide-react';
import PaymentTipSelector from './PaymentTipSelector';

const formatAmount = (amountCents, currencyCode = 'USD') => {
  if (amountCents == null || amountCents === 0) return null;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode.toUpperCase(),
  }).format(amountCents / 100);
};

const PaymentOrderSummary = ({
  lineItems,
  formattedTotal,
  subtotalCents = 0,
  convenienceFeeCents = 0,
  currentTipCents = 0,
  currency = 'USD',
  onTipChange,
  isTipUpdating = false,
  businessName = 'Payment',
}) => {
  const formattedSubtotal = formatAmount(subtotalCents, currency);

  return (
    <div className="order-summary-column">
      <div className="order-summary-header">
        <div className="header-content">
          <div className="business-info">
            <div className="business-icon">
              <Store size={24} strokeWidth={2} />
            </div>
            <p className="business-name">{businessName}</p>
          </div>
        </div>
      </div>

      <div className="order-details-body">
        <div className="order-total-block">
          <div className="order-total-text">
            <p className="order-total-title">Subtotal</p>
            <p className="order-total-amount">{formattedSubtotal || '--'}</p>
          </div>
        </div>

        <ul className="order-details-items">
          {(lineItems || []).map((item) => (
            <li key={item.id} className="order-details-item">
              <div className="line-item-content">
                <div>
                  <p className="line-item-name">{item.name}</p>
                  {item.description && <p className="line-item-description">{item.description}</p>}
                </div>
                {item.lineTotalDisplay && (
                  <p className="line-item-price">{item.lineTotalDisplay}</p>
                )}
              </div>
              <div className="line-item-meta">
                <span className="line-item-quantity">Qty {item.quantity}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {onTipChange && (
        <PaymentTipSelector
          subtotalCents={subtotalCents}
          currentTipCents={currentTipCents}
          currency={currency}
          onTipChange={onTipChange}
          isUpdating={isTipUpdating}
        />
      )}
    </div>
  );
};

export default PaymentOrderSummary;
